import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import PSBookedBanner from '@/components/PSBookedBanner';
import PSText from '@/components/ui/PSText';

const PREVIEWS: {
  id: string;
  label: string;
  title: string;
  subtitle: string;
  ctaTitle: string;
  variant?: 'default' | 'gray';
}[] = [
  {
    id: 'design',
    label: 'The design reference',
    title: 'Event booked.',
    subtitle: 'Coming up in 3 days.',
    ctaTitle: 'View Booking',
    variant: 'gray',
  },
  {
    id: 'hours',
    label: 'Hours out instead of days',
    title: 'Event booked.',
    subtitle: 'Coming up in 5 hours.',
    ctaTitle: 'View Booking',
  },
  {
    id: 'rsvp',
    label: 'An RSVP event — the caller swaps every string',
    title: 'RSVP confirmed.',
    subtitle: 'Coming up on Sat 27 Sep.',
    ctaTitle: 'View RSVP',
  },
  {
    id: 'long',
    label:
      'Long copy on both sides — the text column shrinks, the CTA does not',
    title: 'Your booking is confirmed.',
    subtitle:
      'Coming up in 12 days at The Long Named Rooftop Bar and Listening Room.',
    ctaTitle: 'View all my bookings',
  },
  {
    id: 'short',
    label: 'Short copy — the CTA stays right-aligned',
    title: 'Booked.',
    subtitle: 'Today.',
    ctaTitle: 'View',
  },
];

export default function BookedBannerPreview() {
  return (
    <>
      <Head>
        <title>BookedBanner · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack items="flex-start" gap="$lg" p="$lg">
          {PREVIEWS.map((preview) => (
            <YStack key={preview.id} gap="$xs" alignSelf="stretch">
              <PSText.Body3 color="$textDarkMuted">
                {preview.label}
              </PSText.Body3>
              <PSBookedBanner
                title={preview.title}
                subtitle={preview.subtitle}
                ctaTitle={preview.ctaTitle}
                onPress={() => {}}
                variant={preview.variant}
              />
            </YStack>
          ))}
        </YStack>
      </ScrollView>
    </>
  );
}
